"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StreamWidgetContainer = require("./StreamWidgetContainer");
Object.keys(_StreamWidgetContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StreamWidgetContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StreamWidgetContainer[key];
    }
  });
});